"use client";

import {
  createContext,
  useContext,
  useState,
  type ComponentProps,
  type ReactNode,
} from "react";

import { ContactFormDialog } from "@/components/contact-form-dialog";
import { Button } from "@/components/ui/button";

const LensContactContext = createContext<(() => void) | null>(null);

export function LensContactProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const openDialog = () => setOpen(true);

  return (
    <LensContactContext.Provider value={openDialog}>
      {children}
      <ContactFormDialog open={open} onOpenChange={setOpen} />
    </LensContactContext.Provider>
  );
}

function useLensContactDialog() {
  const openDialog = useContext(LensContactContext);

  if (!openDialog) {
    throw new Error("Lens contact controls must be used inside LensContactProvider");
  }

  return openDialog;
}

type LensContactButtonProps = Omit<ComponentProps<typeof Button>, "asChild" | "onClick">;

export function LensContactButton({
  children = "Talk to our team",
  type = "button",
  ...props
}: LensContactButtonProps) {
  const openDialog = useLensContactDialog();

  return (
    <Button type={type} onClick={openDialog} {...props}>
      {children}
    </Button>
  );
}
